import { render, staticRenderFns } from "./MySchools.vue?vue&type=template&id=7d6ddc43&scoped=true&"
import script from "./MySchools.vue?vue&type=script&lang=js&"
export * from "./MySchools.vue?vue&type=script&lang=js&"
import style0 from "./MySchools.vue?vue&type=style&index=0&id=7d6ddc43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ddc43",
  null
  
)

export default component.exports